import PassiveAuthWrapper from './PassiveAuthWrapper';

export default PassiveAuthWrapper;
